import React from 'react'

import { Card, Typography, Box, Divider } from '@material-ui/core'

import useCheckoutList from './useCheckoutList'

import CheckoutItem from '../CheckoutItem'

export default function CheckoutList() {
  const { checkoutItems, shouldCheckoutStart } = useCheckoutList()
  return (
    <Card elevation={5} data-hook="checkoutList-container">
      <Box py={5} px={6}>
        <Typography variant="h3">Pedidos</Typography>
      </Box>
      <Divider />
      <Box px={6} py={6}>
        {shouldCheckoutStart ? (
          checkoutItems?.map((checkoutItem) => (
            <CheckoutItem
              key={checkoutItem.line?.lineNumber}
              line={checkoutItem.line}
              status={checkoutItem.status}
              dataHook={checkoutItem.dataHook}
            />
          ))
        ) : (
          <Typography variant="body1" data-hook="start-beginning-message">
            Por favor, inicie un proceso de venta para poder realizar el pedido.
          </Typography>
        )}
      </Box>
    </Card>
  )
}
